const baseUrl = `https://science-and-leadership.com/metadata/`

const metaImages = {
  logo: `${baseUrl}logo.png`,
  default: `${baseUrl}meta-image-default.png`,
}

export { metaImages }
